import React, { useMemo } from 'react';
import ConfirmModal from '../../common/ConfirmModal/ConfirmModal';
import { formatCurrency } from '../../../utils';
import type { PaymentSystem } from '../../../types';
import styles from './CreateChargeModal.module.css';

interface CreateChargeModalProps {
  open: boolean;
  loading: boolean;
  defaultAmount: number;
  planName: string | null;
  provider: PaymentSystem | null;
  autoRenew: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const PORTAL_PAYMENT_DUE_DAYS = 3;

const getPortalDueDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + PORTAL_PAYMENT_DUE_DAYS);
  return date.toISOString().split('T')[0];
};

const formatDateLabel = (dateOnly: string) => (
  new Date(`${dateOnly}T00:00:00`).toLocaleDateString('pt-BR')
);

const CreateChargeModal: React.FC<CreateChargeModalProps> = ({
  open,
  loading,
  defaultAmount,
  planName,
  provider,
  autoRenew,
  onConfirm,
  onCancel,
}) => {

  const isStripe = provider === 'stripe';
  const dueDateLabel = useMemo(() => formatDateLabel(getPortalDueDate()), []);

  const message = useMemo(() => {
    const planLabel = planName ? ` ${planName}` : '';
    const amountLabel = formatCurrency(defaultAmount);

    if (isStripe) {
      return `Será gerada uma cobrança avulsa vinculada à assinatura${planLabel} no Stripe, no valor de ${amountLabel} com vencimento previsto para ${dueDateLabel}. Se já existir fatura em aberto da assinatura, ela será reutilizada.`;
    }

    return `Será gerada uma cobrança vinculada à assinatura${planLabel} no gateway, no valor de ${amountLabel} com vencimento previsto para ${dueDateLabel}. Se já existir cobrança pendente da assinatura, ela será reutilizada.`;
  }, [defaultAmount, dueDateLabel, isStripe, planName]);

  return (
    <ConfirmModal
      open={open}
      variant="warning"
      icon="receipt_long"
      title="Gerar cobrança"
      message={message}
      confirmLabel={loading ? 'Aguarde...' : 'Gerar cobrança'}
      cancelLabel="Cancelar"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {autoRenew && (
        <p className={styles.autoRenewWarning}>
          Atenção: o plano desta aluna possui renovação automática ativa. Esta cobrança avulsa é adicional e não substitui as cobranças futuras do ciclo da assinatura.
        </p>
      )}
    </ConfirmModal>
  );
};

export default CreateChargeModal;
